<template>
    <div class="row">
        <div class="col-12">
            <div style="font-weight: 600;color:#5F5C5D;margin-bottom: 13px">
<!--                Pottorf > Quick Reference > {{this.types[this.menu - 1]}}-->
            </div>
            <h3 style="color: #426590;margin-bottom:15px;font-family: Helvetica">Quick Reference</h3>
            <div class="header-quick-filter-min" v-if="this.menu == 1 || this.menu == 0">
                <span class="icon-caret-down" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu == 1"></span>
                <span class="icon-caret-right" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu != 1"></span>
                <span class="item-quick-menu" @click="load(0,'Low to Medium Velocity/Pressure',1)">Backdraft Dampers</span><br>
                <div v-if="this.menu == 1" style="margin-top: 15px;">
                    <button class="btn btn-primary" @click="load(1,'Low to Medium Velocity/Pressure',1)">Low to Medium Velocity/Pressure</button>
                    <button class="btn btn-primary" @click="load(2,'Medium to High Velocity/Pressure',1)">Medium to High Velocity/Pressure</button>
                    <button class="btn btn-primary" @click="load(3,'Industrial Duty',1)">Industrial Duty</button>
                </div>
            </div>
            <div class="header-quick-filter-min" v-if="this.menu == 2 || this.menu == 0">
                <span class="icon-caret-down" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu == 2"></span>
                <span class="icon-caret-right" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu != 2"></span>
                <span class="item-quick-menu" @click="load(4,'UL555C Ceiling Radiation Dampers',0)">Ceiling Radiation Dampers</span><br>
            </div>
            <div class="header-quick-filter-min" v-if="this.menu == 3 || this.menu == 0">
                <span class="icon-caret-down" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu == 3"></span>
                <span class="icon-caret-right" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu != 3"></span>
                <span class="item-quick-menu" @click="load(0,'Manual Balancing',3)">Control Dampers</span><br>
                <div v-if="this.menu == 3" style="margin-top: 15px;">
                    <button class="btn btn-primary" @click="load(5,'Manual Balancing',3)">Manual Balancing</button>
                    <button class="btn btn-primary" @click="load(6,'Commercial Control Dampers',3)">Commercial Control</button>
                    <button class="btn btn-primary" @click="load(7,'Industrial Control',3)">Industrial Control</button>
                    <button class="btn btn-primary" @click="load(8,'Thermal',3)">Thermal</button>
                </div>
            </div>
            <div class="header-quick-filter-min" v-if="this.menu == 4 || this.menu == 0">
                <span class="icon-caret-down" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu == 4"></span>
                <span class="icon-caret-right" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu != 4"></span>
                <span class="item-quick-menu" @click="load(0,'Fire Dampers',4)">Fire/Smoke Dampers</span><br>
                <div v-if="this.menu == 4" style="margin-top: 15px;">
                    <button class="btn btn-primary" @click="load(9,'Fire Dampers',4)">Fire Dampers</button>
                    <button class="btn btn-primary" @click="load(10,'Fire/Smoke Dampers',4)">Fire/Smoke Dampers</button>
                    <button class="btn btn-primary"  @click="load(11,'Smoke Dampers',4)">Smoke Dampers</button>
                </div>
            </div>
            <div class="header-quick-filter-min" v-if="this.menu == 5 || this.menu == 0">
                <span class="icon-caret-down" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu == 5"></span>
                <span class="icon-caret-right" style="font-size: 18px;padding-right: 10px;color: #656263;" v-if="this.menu != 5"></span>
                <span class="item-quick-menu" @click="load(0,'Extruded Aluminum',5)">Louvers</span><br>
                <div v-if="this.menu == 5" style="margin-top: 15px;">
                    <button class="btn btn-primary" @click="load(12,'Extruded Aluminum',5)">Extruded Aluminum</button>
                    <button class="btn btn-primary" @click="load(13,'Formed Metal/Steel',5)">Formed Metal/Steel</button>
                    <button class="btn btn-primary" @click="load(14,'Combination/Operable',5)">Combination/Operable</button>
                    <button class="btn btn-primary" @click="load(15,'Acoustical',5)">Acoustical</button>
                    <button class="btn btn-primary" @click="load(16,'Sight Screens/Penthouses',5)">Sight Screens/Penthouses</button>
                </div>
            </div>
            <table border="1" style="width: 100%"  class="header-quick-filter-big">
                <tr>
                    <td style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 1 }" >
                        <div class="dropdown" style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 1 }" >
                            <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%;margin-bottom:0px;color:#64625F;font-weight: 600;font-size: 16px;">
                                <div>
                                    Backdraft Dampers
                                </div>
                                <div style="margin-top: -10px;" v-if="this.backdraft !== ''">
                                    <span style="font-size: 9px;">{{this.backdraft}}</span>
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" @click="load(1,'Low to Medium Velocity/Pressure',1)">Low to Medium Velocity/Pressure</a>
                                <a class="dropdown-item" @click="load(2,'Medium to High Velocity/Pressure',1)">Medium to High Velocity/Pressure</a>
                                <a class="dropdown-item" @click="load(3,'Industrial Duty',1)">Industrial Duty</a>
                            </div>
                        </div>
                    </td>
                    <td style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 2 }" >
                        <div style="background-color: #F7F9FB;"  :class="{ 'quickActive': this.menu == 2 }" >
                            <button @click="load(4,'UL555C Ceiling Radiation Dampers',2)" class="btn" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%;margin-bottom:0px;color:#64625F;font-weight: 600;font-size: 16px;">
                                Ceiling Radiation Dampers
                            </button>
                        </div>
                    </td>
                    <td style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 3 }" >
                        <div class="dropdown" style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 3 }" >
                            <button class="btn" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%;margin-bottom:0px;color:#64625F;font-weight: 600;font-size: 16px;">
                                <div>
                                Control Dampers
                                </div>
                                <div style="margin-top: -10px;" v-if="this.controlDampers !== ''">
                                    <span style="font-size: 9px;">{{this.controlDampers}}</span>
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                <a class="dropdown-item" @click="load(5,'Manual Balancing',3)">Manual Balancing</a>
                                <a class="dropdown-item" @click="load(6,'Commercial Control Dampers',3)">Commercial Control</a>
                                <a class="dropdown-item" @click="load(7,'Industrial Control',3)">Industrial Control</a>
                                <a class="dropdown-item" @click="load(8,'Thermal',3)">Thermal</a>
                            </div>
                        </div>
                    </td>
                    <td style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 4 }" >
                        <div class="dropdown" style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 4 }" >
                            <button class="btn" type="button" id="dropdownMenuButton3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%;margin-bottom:0px;color:#64625F;font-weight: 600;font-size: 16px;">
                                <div>
                                Fire/Smoke Dampers
                                </div>
                                <div style="margin-top: -10px;" v-if="this.fireSmoke !== ''">
                                    <span style="font-size: 9px;">{{this.fireSmoke}}</span>
                                </div>
<!--                                <br><i style="font-size: 12px">Combination</i>-->
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
                                <a class="dropdown-item" @click="load(9,'Fire Dampers',4)">Fire Dampers</a>
                                <a class="dropdown-item" @click="load(10,'Fire/Smoke Dampers',4)">Fire/Smoke Dampers</a>
                                <a class="dropdown-item" @click="load(11,'Smoke Dampers',4)">Smoke Dampers</a>
                            </div>
                        </div>
                    </td>
                    <td style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 5 }" >
                        <div class="dropdown" style="background-color: #F7F9FB;" :class="{ 'quickActive': this.menu == 5 }">
                            <button class="btn" type="button" id="dropdownMenuButton4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100%;margin-bottom:0px;color:#64625F;font-weight: 600;font-size: 16px;">
                                <div>
                                Louvers
                                </div>
                                <div style="margin-top: -10px;" v-if="this.Louvers !== ''">
                                    <span style="font-size: 9px;">{{this.Louvers}}</span>
                                </div>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton4">
                                <a class="dropdown-item" @click="load(12,'Extruded Aluminum',5)">Extruded Aluminum</a>
                                <a class="dropdown-item" @click="load(13,'Formed Metal/Steel',5)">Formed Metal/Steel</a>
                                <a class="dropdown-item" @click="load(14,'Combination/Operable',5)">Combination/Operable</a>
                                <a class="dropdown-item" @click="load(15,'Acoustical',5)">Acoustical</a>
                                <a class="dropdown-item" @click="load(16,'Sight Screens/Penthouses',5)">Sight Screens/Penthouses</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>

            <page-quick-backdraft-dampers v-if="category == 1 || category == 2 || category == 3" :data="this.data" :title="this.title" :category="this.category"></page-quick-backdraft-dampers>

            <page-quick-ceiling-radiation-dampers v-if="category == 4" :data="this.data" :title="this.title" :category="this.category"></page-quick-ceiling-radiation-dampers>

            <page-quick-manual-balancing v-if="category == 5" :data="this.data" :title="this.title" :category="this.category"></page-quick-manual-balancing>

            <page-quick-comercial-control v-if="category == 6" :data="this.data" :title="this.title" :category="this.category"></page-quick-comercial-control>

            <page-quick-industrial-control v-if="category == 7 || category == 8" :data="this.data" :title="this.title" :category="this.category"></page-quick-industrial-control>

            <page-quick-fire-dampers v-if="category == 9 || category == 10" :data="this.data" :title="this.title" :category="this.category"></page-quick-fire-dampers>

            <page-quick-smoke-dampers v-if="category == 11" :data="this.data" :title="this.title" :category="this.category"></page-quick-smoke-dampers>

            <page-quick-extrumed-aluminum v-if="category == 12" :data="this.data" :title="this.title" :category="this.category"></page-quick-extrumed-aluminum>

            <page-quick-louvers v-if="category == 13 || category == 14 || category == 15 || category == 16" :data="this.data" :title="this.title" :category="this.category"></page-quick-louvers>

        </div>

        <div class="col-12" style="font-size: 14px;margin-top: 10px;">
            Click on header to sort the results
        </div>
    </div>
</template>
<script>
export default {
    props: [],
    name: 'quick-reference-show-page',
    data () {
        return {
            data: {},
            products: {},
            category: 0,
            types: ['Backdraft Dampers','Ceiling Radiation Dampers','Control Dampers','Fire/Smoke Dampers','Louvers'],
            menu: 0,
            title: '',
            backdraft: '',
        };
    },
    methods: {
        async load (category,title,menu) {
            const { data } = await axios.get('/api/quickreference/' + category);
            const { quickdata = [], ...products } = data || {};

            this.title = title;
            this.data = data;
            this.category = category;

            if(category == 1 || category == 2 || category == 3){
                this.backdraft = title;
            }
            else
                this.backdraft = '';
            if(category == 5 || category == 6 || category == 7 || category == 8){
                this.controlDampers = title;
            }
            else
                this.controlDampers = '';
            if(category == 9 || category == 10 || category == 11){
                this.fireSmoke = title;
            }
            else
                this.fireSmoke = '';
            if(category == 12 || category == 13 || category == 14 || category == 15 || category == 16){
                this.Louvers = title;
            }
            else
                this.Louvers = '';
            if(category == 0 && menu == this.menu)
                this.menu = 0;
            else
                this.menu = menu;
        }
    },
    watch: {
        selectedSubCategory () {
            if (this.loaded) {
                this.load();
            }
        },
    },
    async mounted () {
        await this.load(1,'Low to Medium Velocity/Pressure',1,this.category);
    }
};
</script>

